"use strict";
var appn;
(function (appn) {
    appn.isDebug = appn.isDebug;
    appn.isTestSuiteRequest = appn.isTestSuiteRequest;
    appn.emptyGuid = appn.emptyGuid;
    appn.emptyString = '';
    String.prototype.endsWithIgnoreCase = function (stringToFind, dontTrim) {
        if (dontTrim)
            return this.toLowerCase().endsWith(stringToFind.toLowerCase());
        return this.trim().toLowerCase().endsWith(stringToFind.trim().toLowerCase());
    };
})(appn || (appn = {}));
